export default __webpack_public_path__ + "static/twitterconnect-789060fd2ef263b1482a219662baaebd.png";